<template>
    <section-layout
      :showButton="false"
    >
      <template v-slot:title>
        {{localization.relacionInteracciones.titulo}}
      </template>
      <template v-slot:content>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <o-medium-title class="pr-5">
                {{localization.filtros.title}}
              </o-medium-title>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <filtrosInteracciones
                tipo="relacionInteracciones"
                :disabled="loading"
                @aplicar="aplicarFiltros"
                @borrar="borrarFiltros"
                @exportar="exportarExcel"
                @toogleHeaderNotas="toogleHeaderNotas"
                @toogleHeaderObservaciones="toogleHeaderObservaciones"
                :itramit="true"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-card class="mt-4">
          <v-container fluid>
            <v-data-table
              :headers="headers"
              :items="incidencias"
              :search="tableSearch"
              :loading="loading"
              item-key="incidenciaId"
              :footer-props="{
                'items-per-page-text': $t('filasPorPagina'),
                'items-per-page-options': [10, 20, 30, 40, 50, -1]
              }"
            >
              <template v-slot:top>
                <v-row no-gutters justify="end" align="center">
                  <v-col cols="4">
                    <v-text-field
                      v-model="tableSearch" id="tableSearch"
                      :label="localization.filtros.buscar" prepend-icon="search"
                    />
                  </v-col>
                </v-row>
              </template>
              <template
                v-slot:body="{ items }">
                <tbody>
                  <tr v-for="item in items" :key="item.identificador">
                    <td>{{ item.referencia }}</td>
                    <td>{{ traduccionTipoSolicitud(item) }}</td>
                    <td>{{ item.inmueble }}</td>
                    <td>{{ item.operacion }}</td>
                    <td>{{ traduccionEstado(item) }}</td>
                    <td>{{ procesarInteraccion(item) }}</td>
                    <td>{{ formateaFechaHora(item.fecha)}}</td>
                    <td>{{ item.descripcion }}</td>
                    <td>{{ item.observaciones }}</td>
                    <td @click="descargarDocumento(item)">
                      {{ procesarAdjunto(item) }}
                    </td>
                    <td>
                      <template v-if="contieneFirma(item)">
                        <img v-bind:src="item.firma.document"  width="100px" />
                      </template>
                    </td>
                    
                    <!-- <td @click="descargarDocumento(item.firma)">
                      {{ procesarFirma(item) }}
                    </td> -->
                    <td>{{ procesarInterlocutor(item) }}</td>
                    <td>{{ item.email }}</td>
                    <td>{{ item.cod_cliente }}</td>
                    <td>{{ item.apellidos }}</td>
                    <td>{{ item.nombre }}</td>
                    <td>{{ item.dni }}</td>
                  </tr>
                </tbody>
              </template>
              <!-- <template v-slot:item.location="{item}">
                <div v-html="item.location"/>
              </template> -->
            </v-data-table>
          </v-container>
        </v-card>
        <v-dialog
          v-model="dialog" id="dialog"
          scrollable
          height="300"
          width="800"
        >
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              {{tituloDialog}}
            </v-card-title>
  
            <v-card-text v-if="notasDialog.length > 0">
              <v-list class="py-0" light>
                <v-list-item-group>
                  <v-list-item
                    v-for="item in notasDialog"
                    :key="item.id"
                    disabled
                  >
                    <v-list-item-content>
                      <span class="primary--text" style="max-width: 100%">
                        {{formateaFecha(item.fecha)}} - {{item.nota}}
                      </span>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card-text>
            <v-card-text v-if="observacionesEstado.length > 0">
              <v-list class="py-0" light>
                <v-list-item-group>
                  <v-list-item
                    v-for="item in observacionesEstado"
                    :key="item.id"
                    disabled
                  >
                    <v-list-item-content>
                      <span class="primary--text" style="max-width: 100%">
                        {{formateaFechaHora(item)}} - {{item.descripcion}} - {{item.observaciones}}
                      </span>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card-text>
  
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="dialog = false">{{$t('cerrar')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
    </section-layout>
  </template>
  
  <script>
  import { mapActions, mapGetters } from 'vuex'
  import filtrosInteracciones from './filtrosInteracciones'
  import mixinExcel from '@/mixins/downloadExcel'
  import moment from 'moment'
  
  export default {
    mixins: [mixinExcel],
    components: {
        filtrosInteracciones
    },
    data () {
      return {
        loading: false,
        tableSearch: '',
        incidencias: [],
        loader: null,
        headerNotas: [],
        headerObservaciones: [],
        headerClientes: [],
        dialog: false,
        tituloDialog: '',
        observacionesEstado: '',
        notasDialog: []
      }
    },
    computed: {
      ...mapGetters ({
        idubapi: 'login/idubapi'
      }),
      localization () {
        return this.$t('sectionInformes')
      },
      usuario() {
        return JSON.parse(localStorage.getItem('usuario'))
      },
      headers () {
  
        return [
          { text: this.localization.filtros.numIncidencia, value: 'referencia'},
          { text: this.localization.relacionIncidencias.tipoSolicitud, value: 'tipoSolicitud' },
          { text: this.localization.filtros.inmueble, value: 'inmueble',width:'180px',align: 'center'},
          { text: this.localization.relacionInteracciones.operacion, value: 'operacion' },
          { text: this.localization.filtros.estado, value: 'estado' },
          { text: this.localization.relacionInteracciones.interaccion, value: 'interaccion' },
          { text: this.localization.relacionInteracciones.fecha, value: 'date' },
          { text: this.localization.relacionIncidencias.descripcion, value: 'descripcion', width:'200px',align: 'center'},
          { text: this.localization.relacionIncidencias.observaciones, value: 'observaciones', width:'200px',align: 'center'},
          { text: this.localization.relacionInteracciones.adjunto, value: 'adjunto' },
          { text: this.localization.relacionInteracciones.firma, value: 'firma' },
          { text: this.localization.relacionInteracciones.interlocutor, value: 'interlocutor' },
          { text: this.localization.filtros.email, value: 'email' },
          { text: this.localization.relacionIncidencias.cliente, value: 'cod_cliente' },
          { text: this.localization.relacionInteracciones.apellidos , value: 'apellidos' },
          { text: this.localization.relacionInteracciones.nombre, value: 'nombre' },
          { text: this.localization.relacionInteracciones.nDocumento, value: 'dni' },
        ]
      },
      singleDoc () {
      if (this.$store.state.incidencias.singleDoc) {
        return this.$store.state.incidencias.singleDoc
      }
      return []
    }
    },
    methods: {
      ...mapActions({
        addAlert: 'alerts/add',
        getIncidencias: 'informes/getInteracionesIncidencias',
        getDocumentsById: 'incidencias/getDocumentsById',
      }),
      toogleHeaderNotas (val) {
        this.headerNotas = val ? [{ text: this.localization.relacionIncidencias.notas, value: 'notas' }] : []
      },
      toogleHeaderObservaciones (val) {
        this.headerObservaciones = val ? [{ text: this.localization.relacionIncidencias.observacionesEstado, value: 'observaciones' }] : []
      },
      async aplicarFiltros (values) {
        console.log('VALUES: ', values)

        try {
          this.loading = true
          this.loader = this.$loading.show({
            // Optional parameters
            container: this.fullPage ? null : this.$refs.formContainer,
            canCancel: false,
            onCancel: this.onCancel,
          })
          var respuesta = await this.getIncidencias(values)
          // console.log("respuesta", respuesta);
          this.incidencias = respuesta.data
        } catch (error) {
          console.log('ERROR AL CARGAR DATOS? filtros', error)
          this.addAlert({ texto: this.$t('errorCargaDeDatos'), color: 'error' })
        }
        this.loading = false
        this.loader.hide()
      },
      borrarFiltros () {
        this.incidencias = []
      },
      async exportarExcel (values) {
        try {
          this.loading = true
          this.loader = this.$loading.show({
            // Optional parameters
            container: this.fullPage ? null : this.$refs.formContainer,
            canCancel: false,
            onCancel: this.onCancel,
          })
          let csv = await this.getIncidencias(values)
          this.downloadExcel(csv.file || csv.data)
        } catch (error) {
          console.log('ERROR AL CARGAR DATOS? descarga', error)
          this.addAlert({ texto: this.$t('errorCargaDeDatos'), color: 'error' })
        }
        this.loading = false
        this.loader.hide()
      },
      formateaFecha(fecha) {
        return moment(fecha, 'YYYY-MM-DD').format('DD/MM/YYYY')
      },
      formateaFechaHora(fecha) {
        return moment(fecha, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')
      },
      traduccionTipoSolicitud (item) {
        if(this.usuario.idioma === 'spa') {
          return item.tipoSolicitud
        } else {
          let tradTipoSolicitud = JSON.parse(item.traduccionTipoSolicitud)
          if(tradTipoSolicitud) {
            return tradTipoSolicitud[this.usuario.idioma] || item.tipoSolicitud
          } else {
            return item.tipoSolicitud
          }
        }
      },
      traduccionEstado (item) {
        if(this.usuario.idioma === 'spa') {
          return item.desc_estado
        } else {
          let tradEstado = JSON.parse(item.traduccionEstado)
          if(tradEstado) {
            return tradEstado[this.usuario.idioma] || item.desc_estado
          } else {
            return item.desc_estado
          } 
        }
      },
      contieneFirma(item){
        if(item.firma === null){
          return false
        }else if(item.firma.document === null || item.firma.document == ""){
          return false
        }else{
          return  true
        }
      },
      procesarFirma(item){
        if(item.firma === null){
          return null
        }else{
          return item.firma.nombre
        }
      },
      procesarAdjunto(item){
        if(item.adjunto === null){
          return null
        }else{
          return item.adjunto.nombre
        }
      },
      procesarInteraccion(item){
        let textInteraccion = ""
        switch (item.interaccion) {
          case "alta":
            textInteraccion = this.localization.relacionInteracciones.alta
            break;
          case "chat":
            textInteraccion = this.localization.relacionInteracciones.comunicacion
            break;
          case "docs":
            textInteraccion = this.localization.relacionInteracciones.documentacion
            break;
          case "firma":
            textInteraccion = this.localization.relacionInteracciones.firma
            break;
          case "cambio_est":
            textInteraccion = this.localization.relacionInteracciones.cambio_estado
            break;
          case "cambio_tipo":
            textInteraccion = this.localization.relacionInteracciones.cambio_tipo
            break;
          case "nota":
            textInteraccion = this.localization.relacionIncidencias.notas
            break;
          case "parte":
            textInteraccion = this.localization.relacionInteracciones.generarParte
            break;
        }
        return textInteraccion
      },
      procesarInterlocutor(item){
        let textIntelocutor = "";
        switch (item.interlocutor) {
          case "vendedor":
            textIntelocutor = this.localization.relacionInteracciones.vendedor
            break;
          case "arrendador":
            textIntelocutor = this.localization.relacionInteracciones.arrendador
            break;
          case "responsable":
            textIntelocutor = this.localization.estadisticas.responsable
            break;
          case "proveedor":
            textIntelocutor = this.localization.estadisticas.proveedor
            break;
          case "comprador":
            textIntelocutor = this.localization.relacionInteracciones.comprador
            break;
          case "arrendatario":
            textIntelocutor = this.localization.relacionInteracciones.arrendatario
            break;
          case "cliente":
            textIntelocutor = this.localization.relacionIncidencias.cliente
            break;
        }
        return textIntelocutor
      },
      descargarDocumento (item) {
        if(item.adjunto === null){
          return
        }
        //++ CUANDO ES UN DOCUMENTO ADJUNTO DEL CHAT
        if(item.interaccion == "chat"){
          console.log(item.adjunto)
          var binario = atob(item.adjunto.document.toString().replace(/(\r\n|\n|\r)/gm ,''))
          var array = []
          for (var i = 0; i < binario.length; i++) {
            array.push(binario.charCodeAt(i))
          }
          var blob = new Blob([new Uint8Array(array)], { type: item.adjunto.mime })
          if (window.navigator.msSaveBlob) {
            window.navigator.msSaveOrOpenBlob(blob, item.adjunto.nombre)
          } else {
            var a = window.document.createElement('a')
            a.href = window.URL.createObjectURL(blob, { type: item.adjunto.mime })
            a.download = item.adjunto.nombre
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
          }
          this.loader.hide()
          return;
        }
        //++ SI ES UN DOCUMENTO NORMAL
        let id = item.adjunto.id
        this.loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false,
          onCancel: this.onCancel,
        })

        this.getDocumentsById(id)
        .then(() => {
          var binario = atob(this.singleDoc[0].document.toString().replace(/(\r\n|\n|\r)/gm ,''))
          var array = []
          for (var i = 0; i < binario.length; i++) {
            array.push(binario.charCodeAt(i))
          }
          var blob = new Blob([new Uint8Array(array)], { type: this.singleDoc[0].mime })
          if (window.navigator.msSaveBlob) {
            window.navigator.msSaveOrOpenBlob(blob, this.singleDoc[0].name)
          } else {
            var a = window.document.createElement('a')
            a.href = window.URL.createObjectURL(blob, { type: this.singleDoc[0].mime })
            a.download = this.singleDoc[0].name
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
          }
          this.loader.hide()
        })
        .catch(e => {
          return e
        })
    }
      
    }
  }
  </script>
  
  <style scoped>
  .recortarStyle {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      max-width: 150px;
    }
  </style>
  